import { render, staticRenderFns } from "./CourseAccordion.vue?vue&type=template&id=1413114f&scoped=true"
import script from "./CourseAccordion.vue?vue&type=script&lang=ts"
export * from "./CourseAccordion.vue?vue&type=script&lang=ts"
import style0 from "./CourseAccordion.vue?vue&type=style&index=0&id=1413114f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1413114f",
  null
  
)

export default component.exports